var map = {
	".": 6467,
	"./": 6467,
	"./admin": 8717,
	"./admin/": 8717,
	"./admin/admininfo": 9958,
	"./admin/admininfo.js": 9958,
	"./admin/allusers": 4757,
	"./admin/allusers.js": 4757,
	"./admin/component": 5041,
	"./admin/component.js": 5041,
	"./admin/createtransaction": 1336,
	"./admin/createtransaction/": 1336,
	"./admin/createtransaction/changewallet": 2767,
	"./admin/createtransaction/changewallet.js": 2767,
	"./admin/createtransaction/createtransaction": 3182,
	"./admin/createtransaction/createtransaction.js": 3182,
	"./admin/createtransaction/index": 1336,
	"./admin/createtransaction/index.js": 1336,
	"./admin/createtransaction/usertransaction": 9674,
	"./admin/createtransaction/usertransaction.js": 9674,
	"./admin/index": 8717,
	"./admin/index.js": 8717,
	"./admin/transactions": 6914,
	"./admin/transactions.js": 6914,
	"./allcoins": 941,
	"./allcoins.js": 941,
	"./allcoinsaction": 6045,
	"./allcoinsaction.js": 6045,
	"./authentication": 6400,
	"./authentication/": 6400,
	"./authentication/directlogin": 6235,
	"./authentication/directlogin.js": 6235,
	"./authentication/index": 6400,
	"./authentication/index.js": 6400,
	"./authentication/login": 4319,
	"./authentication/login.js": 4319,
	"./authentication/logo": 2053,
	"./authentication/logo.js": 2053,
	"./authentication/phraselogin": 7398,
	"./authentication/phraselogin.js": 7398,
	"./authentication/resetpassword": 1966,
	"./authentication/resetpassword.js": 1966,
	"./authentication/signup": 7286,
	"./authentication/signup.js": 7286,
	"./authentication/signupbackup": 8377,
	"./authentication/signupbackup.js": 8377,
	"./coin": 7757,
	"./coin.js": 7757,
	"./connectwallet": 1512,
	"./connectwallet.js": 1512,
	"./images/coins/bnb.svg": 7923,
	"./images/coins/btc.svg": 8591,
	"./images/coins/eth.svg": 4629,
	"./images/coins/trx.svg": 529,
	"./images/coins/usdt(erc20).svg": 1192,
	"./images/coins/usdt.svg": 2569,
	"./index": 6467,
	"./index.js": 6467,
	"./phrase": 1136,
	"./phrase.js": 1136,
	"./profile": 9068,
	"./profile.js": 9068,
	"./recievemodal": 7428,
	"./recievemodal.js": 7428,
	"./send": 3685,
	"./send.js": 3685,
	"./settings": 4618,
	"./settings.js": 4618,
	"./styles.scoped.css": 2700,
	"./transactionhistory": 2585,
	"./transactionhistory.js": 2585,
	"./verification": 9313,
	"./verification/": 9313,
	"./verification/index": 9313,
	"./verification/index.js": 9313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9100;